import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { SpeechToTextResultEvent } from '@progress/kendo-react-buttons';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

import { PromptBox } from './PromptBox';
import { Gradient } from '../../../common/components/Gradient';
import { Footer } from '../../../common/components/Footer';
import { DOCUMENT_OPTIONS, getDefaultDocument } from '../../../constants';
import { DocumentOption } from '../../../types';

export const PepsiCoRag: React.FC = () => {
    const navigate = useNavigate();

    const [query, setQuery] = useState("");
    const [ddlValue, setDdlValue] = useState<{ value: DocumentOption }>({
        value: getDefaultDocument()
    });
    const [ISEnabled, setISEnabled] = useState<boolean>(false);
    const [IEnabled, setIEnabled] = useState<boolean>(true);

    const handleDocClick = (doc: DocumentOption) => {
        setDdlValue({ value: doc });
    };

    const handleSendButtonClick = () => {
        navigate("/pepsico-rag-chat", {
            state: {
                doc: ddlValue,
                query,
                isInternetSearchEnabled: ISEnabled,
                isInternalEnabled: IEnabled
            }
        });
    };

    const handleQueryChange = (event: any) => {
        setQuery(event.value);
    };

    const handleToggleISEnabled = () => {
        const newValue = !ISEnabled;
        if (newValue === true) {
            setISEnabled(true);
            return;
        }

        if (newValue === false && IEnabled === false) {
            alert('At least one data source must be enabled. Either Internal Data or Internet Search must be active.');
            return
        }
        else {
            setISEnabled(false);
        }
    };

    const handleToggleIEnabled = () => {
        const newValue = !IEnabled;
        if (newValue === true) {
            setIEnabled(true);
            return;
        }

        if (newValue === false && ISEnabled === false) {
            alert('At least one data source must be enabled. Either Internal Data or Internet Search must be active.');
            return;
        }
        else {
            setIEnabled(false);
        }
    };

    const handleDdlValueChange = (event: DropDownListChangeEvent) => {
        setDdlValue({ value: event.target.value });
    };

    const onSpeechToTextResult = (event: SpeechToTextResultEvent) => {
        const { isFinal, alternatives } = event;
        if (isFinal && alternatives.length > 0) {
            setQuery(alternatives[0].transcript);
        }
    };

    return (
        <Gradient>
            <section className="home-section k-pos-relative">
                <div className="k-d-flex k-align-items-center k-justify-content-center hero-wrapper">
                    <div className="k-d-flex k-flex-column k-text-center k-flex-1 k-gap-8">
                        <h1 className="gradient-heading home-heading-padding k-mt-20 k-mb-8">
                            Research Assistant
                        </h1>
                        <p className="k-font-size-xl k-text-center k-flex-1 !k-mb-0">
                            Get answers with reasoning from multiple sources <br />
                            Choose your dataset and enable internet search to get started <br />
                        </p>
                    </div>
                </div>
            </section>

            <section className="k-pos-relative k-d-flex k-flex-column k-gap-lg">
                <div className="k-d-flex k-flex-column k-align-items-center k-w-full">
                    <div className="k-d-flex k-flex-wrap k-justify-content-center k-align-items-center k-gap-lg-8 k-gap-md-6 k-gap-3 k-w-full">
                        {DOCUMENT_OPTIONS.map((doc) => (
                            <div
                                key={doc.id}
                                className='demo-card k-elevation-2'
                                onClick={() => handleDocClick(doc)}
                            >
                                <div className="demo-card-icon">
                                    <img
                                        className="home-demo-icon"
                                        src={doc.icon}
                                        alt={doc.name}
                                    />
                                </div>
                                <div className="k-d-flex k-flex-column k-gap-2">
                                    <div className="k-font-size-md">{doc.name}</div>
                                    <span className="doc-details">{doc.details}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <PromptBox
                    ISEnabled={ISEnabled}
                    handleToggleISEnabled={handleToggleISEnabled}
                    IEnabled={IEnabled}
                    handleToggleIEnabled={handleToggleIEnabled}
                    query={query}
                    handleQueryChange={handleQueryChange}
                    docs={DOCUMENT_OPTIONS}
                    ddlValue={ddlValue}
                    handleDdlValueChange={handleDdlValueChange}
                    handleSendButtonClick={handleSendButtonClick}
                    onSpeechToTextResult={onSpeechToTextResult}
                />
            </section>

            <Footer />
        </Gradient>
    );
};